import React from "react"
import Container from "@/components/container"
import * as styles from "./index.module.scss"
import cls from "classnames"
import { LinkModule } from "@/components"
import { contactFormId } from ".."

const AllSolutions = () => {
  const edges = [
    {
      node: {
        id: "1",
        title: "TiDB OLTP Scale 通用解决方案",
        description:
          "适用于业务对数据库弹性伸缩的诉求，简化系统架构，提高可用性和稳定性。",
      },
    },
    {
      node: {
        id: "2",
        title: "TiDB 联机 T + 0 查询解决方案",
        description:
          "适用于 OLTP 与 OLAP 混合负载、实时数字化营销等场景，促进数据价值实时变现。",
      },
    },
    {
      node: {
        id: "3",
        title: "TiDB ECIF 解决方案",
        description:
          "适用于企业 ECIF 数据快速增长及高并发复杂查询等场景需求，简化系统复杂度。",
      },
    },
    {
      node: {
        id: "4",
        title: "TiDB 分布式批量解决方案",
        description:
          "适用于网络贷款核算、核心批量核算、统一对账平台等分布式跑批典型场景。",
      },
    },
    {
      node: {
        id: "5",
        title: "TiDB 实时数据服务解决方案",
        description:
          "适用于实时监控、实时大屏、实时营销、实时搜索、实时资产、实时 AI 等场景。",
      },
    },
    {
      node: {
        id: "6",
        title: "TiDB 实时风控解决方案",
        description:
          "适用于大数据场景下风控数据的存储及加工，统一入口，打造实时风控弹性架构。",
      },
    },
    {
      node: {
        id: "7",
        title: "TiDB 实时数仓解决方案",
        description:
          "适用于实时数仓应用场景，提供灵活多样的准实时接入模式，简化技术栈。",
      },
    },
    {
      node: {
        id: "8",
        title: "TiDB 综合数据服务平台解决方案",
        description:
          "适用于多源/多分片汇聚、实时计算/分析、数据中枢等典型场景。",
      },
    },
    {
      node: {
        id: "9",
        title: "TiDB 交易与核算分离解决方案",
        description:
          "适用于统一会计核算平台（会计引擎），提速对亿级会计流水、分录数据的批处理任务，敏捷响应产品创新和监管要求。",
      },
    },
    {
      node: {
        id: "10",
        title: "互联网端交易（理财）解决方案",
        description:
          "适用于金融机构与互联网生态深度结合的，具有小额、高频、联机批量混合负载等特点的理财业务场景。",
      },
    },
    {
      node: {
        id: "11",
        title: "TiDB 反欺诈解决方案",
        description:
          "适用于互联网电商与金融、新经济餐饮与零售等行业，有助于对抗各类诈骗、薅羊毛、骗贷等黑色产业。",
      },
    },
    {
      node: {
        id: "12",
        title: "TiDB 营销中心实时营销解决方案",
        description:
          "适用于金融行业面向不同客群实现精准营销服务，提供高并发的实时营销能力。",
      },
    },
  ]

  return (
    <div className={styles.container}>
      <Container>
        <ul className={"columns is-variable is-4 is-multiline is-flex"}>
          {edges.map(({ node }: { node: StrapiSolutions }) => (
            <li
              key={node.id}
              className={"column is-full-mobile is-half-tablet is-one-quarter"}
            >
              <h4 className={styles.h4}>{node.title}</h4>
              <p className={cls(styles.p1)}>{node.description}</p>
            </li>
          ))}
        </ul>
        <div
          className={cls(
            "is-flex is-justify-content-center",
            styles.moreButton
          )}
        >
          <LinkModule to={`#${contactFormId}`}>咨询解决方案详情</LinkModule>
        </div>
      </Container>
    </div>
  )
}

export default AllSolutions
